export enum ModuleTokens {
  Name = 'ticketAdd'
}
